import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSafeTranslation } from '../hooks/useSafeTranslation';

export interface SoloQuizQuitConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

/** First-step solo quit confirmation — shared by Genius, Tile Match, Word Connect, etc. */
const SoloQuizQuitConfirmModal: React.FC<SoloQuizQuitConfirmModalProps> = ({
  show,
  onHide,
  onConfirm,
}) => {
  const { t } = useSafeTranslation();

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('quiz.quitQuizModal', 'Quit Quiz?')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t('quiz.quitQuizBody', 'Your progress will be lost.')}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {t('quiz.quitConfirm', 'Quit')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SoloQuizQuitConfirmModal;
